var map = {
	"./End Note (2005) - 16 mm film strip 1.jpg": 8420,
	"./End Note (2005) - 16 mm film strip 2.jpg": 848,
	"./End Note (2005) - 16 mm film strip 3.jpg": 6854,
	"./End Note (2005) - Digital frame grab 1.jpg": 6548
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 278;